import React from 'react';
import isNil from 'lodash/isNil';
import { Chip, ChipList } from '@progress/kendo-react-buttons';
import { Label } from '@progress/kendo-react-labels';

const BaseChipList = ({
  flat = true,
  onItemRemove,
  className,
  selection = 'none',
  textField = 'value',
  valueField = 'value',
  data,
  onChange,
  value,
  label,
  ...props
}) => {
  const listData = flat ? data.map((item) => ({ value: item })) : data;

  const getValue = () => {
    if (flat) {
      return value;
    }
    return isNil(value) ? value : value[valueField];
  };

  const removeItemHandler = (dataItem) => () => {
    if (!onItemRemove) {
      return;
    }
    const value = dataItem[valueField];
    onItemRemove(value);
  };

  const handleChange = (e) => {
    if (!onChange) {
      return;
    }
    const { value } = e;
    const newValue = flat ? value : data.find((d) => d[valueField] === value);
    onChange({ ...e, value: newValue, target: { ...e.target, value: newValue } });
  };

  const removable = !isNil(onItemRemove);

  if (!label) {
    return (
      <ChipList
        className={className}
        chip={(props) => (
          <Chip
            {...props}
            removable={removable}
            onRemove={removable ? removeItemHandler(props.dataItem) : undefined}
          />
        )}
        selection={selection}
        data={listData}
        textField={textField}
        valueField={valueField}
        onChange={handleChange}
        value={getValue()}
        {...props}
      />
    );
  }

  return (
    <div className='chip-list-wrapper'>
      <Label>{label}</Label>
      <ChipList
        className={className}
        chip={(props) => <Chip {...props} removable={removable} onRemove={removeItemHandler(props.dataItem)} />}
        selection={selection}
        data={listData}
        textField={textField}
        valueField={valueField}
        onChange={handleChange}
        value={getValue()}
        {...props}
      />
    </div>
  );
};

BaseChipList.displayName = 'ChipList';

export default BaseChipList;
